var map = {
	"./1.webp": 5681,
	"./10.webp": 4438,
	"./11.webp": 2348,
	"./12.webp": 781,
	"./13.webp": 8949,
	"./14.webp": 6053,
	"./15.webp": 7812,
	"./16.webp": 5258,
	"./2.webp": 991,
	"./3.webp": 7342,
	"./4.webp": 4764,
	"./5.webp": 8774,
	"./6.webp": 748,
	"./7.webp": 6062,
	"./8.webp": 6330,
	"./9.webp": 4275,
	"./darband.webp": 2243,
	"./gallery/1.webp": 7983,
	"./gallery/11.webp": 1828,
	"./gallery/12.webp": 4385,
	"./gallery/2.webp": 2964,
	"./gallery/4.webp": 9598,
	"./gallery/5.webp": 8668,
	"./gallery/6.webp": 2217,
	"./gallery/9.webp": 2758,
	"./hero.webp": 9640,
	"./menu/m1.webp": 4874,
	"./menu/m2.webp": 2559,
	"./menu/m3.webp": 8056,
	"./menu/m4.webp": 5105,
	"./menu/m5.webp": 2184
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1612;